export default function(element, direction, target, duration) {
  target = Math.round(target)
  duration = Math.round(duration)
  if (duration < 0) {
    return Promise.reject('bad duration')
  }
  if (duration === 0) {
    element[direction] = target
    return Promise.resolve()
  }

  const start_time = Date.now()
  const end_time = start_time + duration

  const start_top = element[direction]
  const distance = target - start_top

  const smooth_step = function(start, end, point) {
    if (point <= start) {
      return 0
    }
    if (point >= end) {
      return 1
    }
    const x = (point - start) / (end - start)
    return x * x * (3 - 2 * x)
  }

  return new Promise(function(resolve, reject) {
    let previous_top = element[direction]

    const scroll_frame = function() {
      if (element[direction] != previous_top) {
        reject('interrupted')
        return
      }

      const now = Date.now()
      const point = smooth_step(start_time, end_time, now)
      const frameTop = Math.round(start_top + distance * point)
      element[direction] = frameTop

      if (now >= end_time) {
        resolve()
        return
      }

      if (element[direction] === previous_top && element[direction] !== frameTop) {
        resolve()
        return
      }
      previous_top = element[direction]

      setTimeout(scroll_frame, 0)
    }

    setTimeout(scroll_frame, 0)
  })
}
